import { getBrandFocusRing } from '../focus';
export const nav = (theme) => ({
    background: theme.colors?.surface?.defaultAlt,
    borderColor: theme.colors?.border.subtle,
    titleColor: theme.colors?.text.basic.secondary,
    item: {
        background: 'inherit',
        color: theme.colors?.text.basic.primary,
        '&:hover': {
            background: theme.colors?.component?.alt?.hover,
            color: theme.colors?.text.basic.primary,
        },
        '&:active': {
            background: theme.colors?.component.brandLight.active,
            color: theme.colors?.text.basic.primary,
        },
        '&:disabled': {
            color: theme.colors?.text?.basic?.disabled,
            background: theme.colors?.surface?.defaultAlt,
            cursor: 'not-allowed',
        },
    },
    selectedItem: {
        background: theme.colors?.component?.brandLight?.default,
        color: theme.colors?.text?.brand,
        borderWidth: 0,
        boxShadow: '0',
        '&:hover': {
            background: theme.colors?.component?.brandLight?.hover,
        },
        '&:active': {
            background: theme.colors?.component?.brandLight?.active,
        },
        '&:focus-visible': {
            outline: 'none',
            boxShadow: getBrandFocusRing(theme, true),
        },
        '&:disabled': {
            color: theme.colors?.text?.basic?.disabled,
            background: theme.colors?.component?.disabled,
            cursor: 'not-allowed',
        },
    },
    header: {
        borderRadius: theme.radii?.sm,
        cursor: 'pointer',
        color: theme.colors?.foreground?.default,
        '&:hover': {
            background: theme.colors?.component?.alt?.hover,
        },
        '&:active': {
            background: theme.colors?.component?.brandLight?.active,
            color: theme.colors?.foreground?.brand,
        },
    },
    icon: {
        color: theme.colors?.text.basic.secondary,
    },
});
//# sourceMappingURL=nav.js.map